import dayjsImport from "./auth-service-tools36.js";

function getMonthsData(year) {
  const startOfYear = dayjsImport(year).startOf("year").toDate();
  const results = [[], [], [], []];
  let currentMonthIndex = 0;

  for (let i = 0; i < 4; i += 1) {
    for (let j = 0; j < 3; j += 1) {
      results[i].push(dayjsImport(startOfYear).add(currentMonthIndex, "months").toDate());
      currentMonthIndex += 1;
    }
  }

  return results;
}

export { getMonthsData };